export const MIN_PASSWORD_LENGTH = 8;
export const PasswordsMustMatchString = "Passwords must match";
export const MAX_REPEATED_CHARACTERS = 3;
const MIN_USERNAME_SUBSTRING_LENGTH = 3;
const PASSWORD = "password";
const REPEATED_CHAR_PATTERN = new RegExp(`(.)\\1{${MAX_REPEATED_CHARACTERS},}`);
const SUBSTITUTIONS: Record<string, string> = {
  '@': 'a', '$': 's', '0': 'o', '1': 'i', '!': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't'
};

export type PasswordReqs = {
  reqTest: (value: string, username? :string) => boolean;
  reqText: string;
};

export const passwordReqs: PasswordReqs[] = [
  {
    reqTest: (password: string) => /^(.*[A-Z])/.test(password),
    reqText: "Contains at least one uppercase character",
  },
  {
    reqTest: (password: string) => /^(.*[a-z])/.test(password),
    reqText: "Contains at least one lowercase character",
  },
  {
    reqTest: (password: string) => /^(.*[0-9])/.test(password),
    reqText: "Contains at least one number",
  },
  {
    reqTest: (password: string) => /^(.*[!@#%&{}><;:|_\-$~`+=[\],.*()'])/.test(password),
    reqText: "Contains at least one special character",
  },
  {
    reqTest: (password: string) => password.length >= MIN_PASSWORD_LENGTH,
    reqText: `Be at least ${MIN_PASSWORD_LENGTH} characters long`,
  },
  {
    reqTest: (password: string, username?: string) => !isUsernamePartInPassword(password, username),
    reqText: "Does not contain username or any part of it",
  },
  {
    reqTest: (password: string) => !containsPasswordWord(password),
    reqText: `Does not contain a form of the word "password"`,
  },
  {
    reqTest: (password: string) => !hasRepeatedCharacters(password),
    reqText: `Does not contain any character more than ${MAX_REPEATED_CHARACTERS} times in succession`,
  },
];

const isUsernamePartInPassword = (password: string, username?: string) => {
  if (!username || !password) return true;
  const usr: string[] = username.split("@");
  const usernameLower = usr[0].toLowerCase();
  const passwordLower = password.toLowerCase();
  for (let i = 0; i < usernameLower.length; i += 1) {
    for (let j = i + MIN_USERNAME_SUBSTRING_LENGTH; j <= usernameLower.length; j += 1) {
      const substring = usernameLower.substring(i, j);
      if (passwordLower.includes(substring)) {
        return true;
      }
    }
  }
  return false;
}

const containsPasswordWord = (password: string) => {
  if (!password) return true;
  const normalized = normalize(password);
  return normalized.includes(PASSWORD);
}

const normalize = (value: string) =>
  value
    .toLowerCase()
    .split('')
    .map((char) => SUBSTITUTIONS[char] || char)
    .join('');

const hasRepeatedCharacters = (password: string) => {
  if (!password) return true;
  return REPEATED_CHAR_PATTERN.test(password);
}
